"use strict";

exports.__esModule = true;
exports.default = void 0;
/* eslint-disable prefer-destructuring */
// default space for margin and padding

var space = ['0', '0.4rem', '0.8rem', '1.2rem', '1.6rem', '2.4rem', '3.2rem', '4.8rem', '7.2rem', '14.4rem'];
space.none = space[0]; // 0px

space.xsmall = space[1]; // 4px

space.small = space[2]; // 8px

space.medium = space[3]; // 12px

space.base = space[4]; // 16px

space.large = space[5]; // 24px

space.xlarge = space[6]; // 32px

space.xxlarge = space[7]; // 48px

space.xxxlarge = space[8]; // 72px

space.xxxxlarge = space[9]; // 144px

var _default = space;
exports.default = _default;